// import { getData } from "./requests/CRUD";  //old code
// export function getSuperUsers() {
//     let data = ['Auto'];
//     getData({tableCode:'TEAM',
//         options:{
//             filterType:'and',
//             filter: [{
//                 text: 'y',
//                 code: 'IS_ADMIN',
//                 type: 'exact',
//             },
//             {
//                 text: 'n',
//                 code: 'DELETED',
//                 type: 'exact',
//             }],
//             order: [{ 
//                 code: 'FIRST_NAME', 
//                 type: 'asc',
//             },{ 
//                 code: 'LAST_NAME', 
//                 type: 'asc',
//             }]
//         },
        
//     }).then((res)=>{
//         if(res && res.success && res.data.length)
//             res.data.map((el)=>{
//                 data.push(el.FIRST_NAME+" "+el.LAST_NAME)
//             })
//             data.push("UPLOADS");
//     });
//     return data;
// }


//due to client passing from dropdow when ever dropdown value change api is trigger to avoid we return below code
import { GET_CONTACT_TEAM_LIST_QUERY } from "./components/Graphql/ContactsQueries/contactsQuery";
// import { GET_MAP_TEAM_MEMBER_QUERY } from "./components/Graphql/Queries/propertiesQuery"; //due to client passing from dropdow when ever dropdown value change api is trigger to avoid we return below code

let isDataFetched = false; // Global flag to track data fetching status
let cachedData = []; // Cache to store fetched data

export function getSuperUsers(client = {}) {

  // Check if data is already fetched
  if (isDataFetched) {
    return cachedData;
  }

  const data = ["Auto"];
  const filterIsagentOption = {
    is_agent: "y",
  };
  const sortNameOption = [
    {
      field: "first_name",
      order: "asc",
    },
    {
      field: "last_name",
      order: "asc",
    },
  ];
  const token = localStorage.getItem("authToken");

  client
    .query({
      // query: GET_MAP_TEAM_MEMBER_QUERY,
      // variables: { filters: [filterIsagentOption], sortOptions: sortNameOption },
      query: GET_CONTACT_TEAM_LIST_QUERY,
      variables: {type:"Team", filters: [filterIsagentOption], sortOptions: sortNameOption },
      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    })
    .then((res) => {
      // if (res && res.data.getTeamMembers.teamMember.length > 0) {
      //   res.data.getTeamMembers.teamMember.map((el) => {
      if (res && res.data.getContacts.data.length > 0) {
        res.data.getContacts.data.map((el) => {
          data.push(el.first_name + " " + el.last_name);
        });
        data.push("UPLOADS");

        // Update cache and set the flag
        cachedData = [...data];
        isDataFetched = true;
      }
    })
    .catch((err) => {
      console.error("Error fetching data", err);
    });

  return data;
}
